import Resource from './Resource'

export default class Proceeding extends Resource {
  static ENDPOINT = '/api/proceeding'

  constructor (args) {
    super()
    this.extend(args)
  }

  static create (training, subject, lectureName, lectureCode) {
    const proceeding = {
      training,
      subject,
      lectureName,
      lectureCode,
      info: {
        name: '',
        date: '',
        time: '',
        place: ''
      },
      teacher: { comment: '' },
      manager: { comment: '' },
      chief: { comment: '' }
    }
    return new Proceeding(proceeding)
  }
}
